import React from 'react';
import PropTypes from 'prop-types';

const Publication = ({ data }) => (
  <article className="publication-container">
    <header>
      <h4 className="publication-title">
        {data.link
          ? <a href={data.link}>{data.title}</a>
          : data.title}
      </h4>
      <p className="publication-authors">{data.authors}</p>
      <p className="publication-venue">
        <i>{data.journal}</i>
        {data.volume ? `, ${data.volume}` : ''}
        {data.issue ? `(${data.issue})` : ''}
        {data.page ? `, ${data.page}` : ''}
        {data.year ? `, ${data.year}` : ''}
      </p>
    </header>
  </article>
);

Publication.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    authors: PropTypes.string.isRequired,
    journal: PropTypes.string.isRequired,
    volume: PropTypes.number,
    issue: PropTypes.number,
    page: PropTypes.number,
    year: PropTypes.number,
    link: PropTypes.string,
  }).isRequired,
};

export default Publication;
